import {
	PageHeader,
	useLayout,
	useNotifications,
	ContentSidebarLayout,
	Colour,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React, { useEffect, useRef, useState } from 'react';
import { faFloppyDisk } from '@fortawesome/pro-solid-svg-icons/faFloppyDisk';
import { createSendsPage, SendsPageItemType, SendsPagesUpdateType, useUpdateSendsData } from '@ukpostbox/client-data';
import CreateStandaloneSendForm from '../Components/CreateSendsForm';
import SendsNavigation from '../../../SendMail/Components/Shared/Controls/SendsNavigation';
import { useSite } from '../../../_Global/Providers/SiteInterfaceProvider';

function CreateSendsPage() {
	const { t } = useTranslation();

	const { AddNotification } = useNotifications();
	const { isTiny, isSmall, isMedium } = useLayout();
	const { currentLocale, updatePageMeta } = useSite();

	const [savingData, setSavingData] = useState<boolean>(false);
	const [saveError, setSaveError] = useState<any>();
	const [saveResp, setSaveResp] = useState(null);

	const sendsTemplates = useUpdateSendsData();

	const sendsCreateRef = useRef<any>(null);
	const sendMailNavigationRef = useRef<any>(null);

	const HandleSave = async (newData: SendsPageItemType) => {
		setSavingData(true);

		await createSendsPage(newData)
			.then((resp: any) => {
				sendsTemplates.mutate({
					updateType: SendsPagesUpdateType.CREATE,
					newData,
				});

				AddNotification({
					title: t('results.sendsCreated'),
					icon: faFloppyDisk,
					colour: Colour.Success,
				});

				setSaveResp(resp);
			})
			.catch((e: any) => {
				setSaveError(e.response.data);
			})
			.finally(() => setSavingData(false));
	};

	useEffect(() => {
		updatePageMeta({
			title: t('sends.create.title'),
		});
	}, [currentLocale]);

	return (
		<ContentSidebarLayout
			ref={sendsCreateRef}
			navigationComponent={<SendsNavigation title={t('sends.create.title')} ref={sendMailNavigationRef} />}
			extraContentClass={`flex-column `}
		>
			{!isTiny && !isSmall && !isMedium && (
				<PageHeader title={t('sends.create.title')} extraClass='section-page-header' />
			)}

			<div className='pt-xl pb-xl p-md'>
				<div className='row mb-xxxl'>
					<div className='col-xs-12 col-xl-6 col-xxl-5 '>
						<CreateStandaloneSendForm
							saveCallback={HandleSave}
							saveResponse={saveResp}
							savingData={savingData}
							error={saveError}
						/>
					</div>
				</div>
			</div>
		</ContentSidebarLayout>
	);
}

export default CreateSendsPage;
